import {CalendarTodayOutlined, ShowChart} from '@mui/icons-material'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {KPIS_WIDGET_NAMESPACE} from '../consts'
import {ChipsToggleOption} from '../types'

export const enum PlantStatusVariant {
  YESTERDAY = 'yesterday',
  TRENDS = 'trends'
}

export const usePlantStatusCardChipsToggle = (
  aggregationMonthsCount: number,
  initialValue = PlantStatusVariant.YESTERDAY
) => {
  const [value, setValue] = useState<PlantStatusVariant>(initialValue)
  const {t} = useTranslation(KPIS_WIDGET_NAMESPACE)

  const options: ChipsToggleOption<PlantStatusVariant>[] = [
    {
      value: PlantStatusVariant.YESTERDAY,
      label: t('label.yesterday'),
      icon: <CalendarTodayOutlined />
    },
    {
      value: PlantStatusVariant.TRENDS,
      label: t('label.monthsCount', {count: aggregationMonthsCount}),
      icon: <ShowChart />
    }
  ]

  const handleChange = (newValue: PlantStatusVariant) => {
    setValue(newValue)
  }

  return {
    value,
    onChange: handleChange,
    options
  }
}
